<div class="p-a-6 bg-col-w"
     [ngClass]="{'p-a-4-s p-b-5-s p-t-5-s' : isCurrent}">
    @if (sectionTitle) {
    <div class="flex flex-middle flex-justify-between">
        <div class="flex flex-top">
            @if (sectionIcon) {
            <i [ngClass]="'icon-' + sectionIcon"
            style="font-size: 1.6em;"
            class="m-r-3"></i>
            }
            <h5 class="s1 inline-block va-m">{{ sectionTitle }}</h5>
        </div>
        @if (isCurrent) {
        <ng-content select="[sectionAction]"></ng-content>
        }
    </div>
    }
    <ng-content select="[sectionBody]"></ng-content>
</div>
